<template>
<transition name="router-anim">
  <div class="registration" id="signup_features">
        
    <div class="card">

        <header class="card-header ">
          <img class="" :src="$t('logoUrl')" alt="logo" style="height:35px; margin: 5px auto;">
        </header>
        <div class="card-content">
          
        <div class="has-text-centered">
          <h3 class="title is-3">{{ $t('SignupFeaturesSelect.features') }}</h3>
        </div>
         
        <div class="form">
          <div class="field">
            <b-checkbox v-model="features.ordering" type="is-info">
              {{ $t('SignupFeaturesSelect.ordering') }}
            </b-checkbox>
            <p>{{ $t('SignupFeaturesSelect.ordering_note') }}</p>
            <b-field v-if="features.ordering" label-position="inside" :label="$t('SignupFeaturesSelect.ordering_email')" class="order-email" style="margin-top:1rem;">
              <b-input type="email" validation-message="*" 
              v-model="ordering.email" ref="orderEmail"></b-input>
            </b-field>
          </div>
          <div class="field">
            <b-checkbox v-model="features.push" type="is-info">
              {{ $t('SignupFeaturesSelect.push') }}
            </b-checkbox>
            <p>{{ $t('SignupFeaturesSelect.push_note') }}</p>
          </div>
          <div class="field">
            <b-checkbox v-model="features.alert18" type="is-info">
              {{ $t('SignupFeaturesSelect.alert18') }}
            </b-checkbox>
            <p>{{ $t('SignupFeaturesSelect.alert18_note') }}</p>
          </div>
      </div>
      
      </div>
      <footer class="has-text-centered">
          <button class="button is-green" :class="{'is-loading':isLoading}" style="margin: 1rem;color:white!important;"
            @click="next()">{{ $t('SignupPlaceInfo.continue') }}</button>
          <div id="status-message">
            <p>{{statusMessage}}</p>
          </div>
        </footer>
    
  </div>
  </div>
</transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "underscore";
const locales = {
    en: {
        cash: "Cash",
        pickup: "Pick up",
        delivery: "Delivery",
        address: "Address",
        name: "Name",
        email: "Email",
        phone: "Phone"
    },
    ru: {
        cash: "Наличные",
        pickup: "Самовывоз",
        delivery: "Доставка",
        address: "Адрес",
        name: "Имя",
        email: "Email",
        phone: "Телефон"
    },
}

export default {
  components: {},

    computed: _.extend(
    {
      buttonText() {
        // if (this.radio == "upload") return this.$t('SignupPlaceInfo.continue')
        return this.$t('SignupPlaceInfo.continue')
      }
    },
    mapGetters({
      info: "getPlaceInfo"
    }),
    {}
  ),

  data() {
    return {
      isLoading: false,
      features: {},
      statusMessage: "",
      ordering: {}
    };
  },

  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    next: function () {
        if (this.features.ordering)
          this.info.ordering = {
            "active": "true",
            "email": this.info.email,
            "integrations": [],
            "fields": {
              "name": {
                "title": locales[this.$i18n.locale].name,
                "hidden": false
              },
              "email": {
                "title": locales[this.$i18n.locale].email,
                "hidden": false
              },
              "phone": {
                "title": locales[this.$i18n.locale].phone,
                "hidden": false
              }
            },
            "payment": {
              "active": true,
              "integrations": [],
              "options": [{
                "type": "cash",
                "name": locales[this.$i18n.locale].cash
              }]
            },
            "delivery": {
              "active": true,
              "integrations": [],
              "options": [
                {
                "type": "pickup",
                "name": locales[this.$i18n.locale].pickup,
                "cost": "0"
                },
                {
                "type": "delivery",
                "name": locales[this.$i18n.locale].delivery,
                "cost": "0"
                },
              ]
            }
          }
      if (this.features.alert18)
        this.info.startModal = "true"

      this.$ma.trackEvent({category: 'event', action: 'Selected functions', properties:{features: JSON.stringify(this.features)}})
      this.isLoading = !this.isLoading;
      this.info.signupStep = "signup_4"
      this.updatePlaceInfo(this.info)
        .then(() => {
              this.isLoading = !this.isLoading;
                // let nextStep = "/dashboard?dialog=checklist"
                let nextStep = "/signup_" + (parseInt(this.$route.path.split("_").pop())+1).toString()
                this.$router.replace(this.$route.query.redirect || nextStep);
        })
        
      },

      }),

  mounted() {
    window.onbeforeunload = function() {
      return "Are you sure you want to exit?";
    };
    
    this.$title = this.$t('title') + " | " + this.$t('Signup.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
    this.ordering.email = this.info.email;
  }
}
</script>

<style scoped>
html {
    overflow: hidden;
}
body {
    background: #fff!important;
  }

.select {
  margin: -10px 10px 2px 25px;
  
}

.field:not(.order-email) {
  border: 1px solid #8080803d;
  padding: 10px;
  border-radius: 6px;
}
.field p {
	color: #889bac;
}
.checkbox {
  font-size: 1.2rem;
  font-weight: 600;
}

.form{
  width: 60%;
  margin: 2rem auto 2rem;
}

.card {
  min-height: 70vh;
}

footer {
  position: sticky;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #8080805c;
  background: white;
}
.order-email .input {
  font-size: 14px; 
  background-color: #dbdbdb8f!important;
}
@media screen and (min-width:768px) {
 .card-content {
    margin-top: 5vh;
  }
}
@media screen and (max-width:768px) {
  /* #signup1 .box {
      padding: 1rem 0rem 2rem;
      box-shadow: none;
  } */

  
  .registration .field:not(:last-child) {
      margin-bottom: 0.75rem;
  }

  .label:not(:last-child) {
    margin-bottom: 0;
  }
 .form{
      width: 100%;
  }


}


@supports (-webkit-appearance:none) {
    .card {
      min-height: calc(100vh - 56px);
    }
}

</style>

